import { BaseResponse } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export enum PictureFrameExamineStatus {
  PENDING = 0, // 待审核
  APPROVED = 1, // 审核通过
  REJECTED = 2, // 审核拒绝
  EXPIRED = 3, // 已过期
}

export interface PictureFrameListParams {
  currentPage?: number;
  pageSize?: number;
  userId?: number;
  id?: number;
  frameName?: string;
  examineStatus?: PictureFrameExamineStatus;
}

export interface PictureFrame {
  id: number;
  frameName: string;
  userId: number;
  userName: string;
  examineStatus: PictureFrameExamineStatus;
  publicationType: number; // 0: 首次发布
  price: number;
}

export interface PictureFrameListResponse {
  total: number;
  records: PictureFrame[];
}

export const getPictureFrameList = async (params: PictureFrameListParams) => {
  const resp = await axiosInstance.post<BaseResponse<PictureFrameListResponse>>(
    `${baseUrl}/picture/frame/userPictureFramelist?currentPage=${params.currentPage}&pageSize=${params.pageSize}`,
    {
      userId: params.userId,
      id: params.id,
      frameName: params.frameName,
      examineStatus: params.examineStatus,
    }
  );
  return resp.data;
};

export enum PictureFrameType {
  PUBLISH = 0, // 发布
  DELETE = 1, // 删除
}

export interface PictureFrameDetail {
  id: number;
  frameName: string;
  userId: number;
  examineStatus: PictureFrameExamineStatus;
  publicationType: number; // 0: 首次发布
  price: number;
  examineUserId: number;
  examineTime: string;
  examineRefuseNotes: string;
  fileSize: string;
  fileType: string;
  frameUrl: string;
  frameType: PictureFrameType;
  salesQuantity: number;
  width: number;
  height: number;
}

export const getPictureFrameDetail = async (id: number) => {
  const resp = await axiosInstance.get<BaseResponse<PictureFrameDetail[]>>(
    `${baseUrl}/picture/frame/detail/${id}`
  );
  return resp.data;
};

export interface PictureFrameExamineParams {
  id: number;
  examineStatus: PictureFrameExamineStatus;
  examineRefuseNotes: string;
}

export const examinePictureFrame = async (
  params: PictureFrameExamineParams
) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/picture/frame/submit`,
    params
  );
  return resp.data;
};
